import { render } from "./technicianDetailInfo.vue?vue&type=template&id=0b2f1a40&ts=true"
import script from "./technicianDetailInfo.vue?vue&type=script&lang=ts"
export * from "./technicianDetailInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__